import {Component, ViewChild, ElementRef} from '@angular/core';
import {Content, NavController, NavParams} from 'ionic-angular';
import {ClosedsalesPage} from '../closedsales/closedsales';
import {Chart} from 'chart.js';
import {BysalesrepPage} from "../bysalesrep/bysalesrep";
import {Api} from "../../providers/api";
import { Storage } from '@ionic/storage';
import {CartManager} from "../../providers/cart-manager";
import {TrendingproductsPage} from "../trendingproducts/trendingproducts";
import set = Reflect.set;
import {GVLogger} from "../../services/gv-logger";


/**
 * Generated class for the ReportsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reports',
  templateUrl: 'reports.html',
})
export class ReportsPage {

  mainPage: any = false;
  closedSale: any = false;
  potentialSales: any;

  @ViewChild(Content) content: Content;
  @ViewChild('pieCanvas') pieCanvas;


  pieChart: any;
  salesRepCheck: any;
  pSalesCheck: any;
  pProductsCheck: any;
  private startDate: any;
  private endDate: any;
  private orderStatus: any;
  private reportStats: any = 0;
  private statByHold: any;
  private storage: Storage;
  private salePerson: any;
  stausTo: any;
  stausFrom: any;
  public stats: any = {
  totalSales: 0,
  averageSales: 0,
    totalOrdersWT: 0,
    customerCountWithOrderWT: 0

};
  constructor(public navCtrl: NavController, public navParams: NavParams, public api: Api, private cartManager: CartManager, private gVLogger: GVLogger) {
    this.salePerson = this.cartManager.getSalesPerson();
    this.mainPage = true;
    this.orderStatus = 2;
    // this.pie1.legend.data = this.salesRepCode;
    let year = new Date().getFullYear();
    this.startDate = new Date(year, 0, 1);
    this.endDate = new Date();
    this.stausTo = this.startDate.toDateString();
    this.stausFrom = this.endDate.toDateString();
    this.gVLogger.log(this.startDate+this.endDate+"year");
    this.reportsStatisticsByHold();
    setTimeout(()=>{
      this.palcedorderstats();
    }, 40);
  }

  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad ReportsPage');
    this.papulateData();


  }

  showClosedSale() {
    // this.salesRepCheck = true;
    // this.pSalesCheck = false;
    // this.pProductsCheck = false;
    //
    // this.closedSale = true;
    // this.salesRepCheck = true;
    // this.potentialSales = false;
    // this.mainPage = false;
    // setTimeout(() => {
    //   this.content.resize();
    // }, 80);
    //
    // var canvas =  <HTMLCanvasElement> document.getElementById("myChart");
    // this.pieCanvas = canvas.getContext('2d');
    // this.papulateData();
    this.navCtrl.push(ClosedsalesPage);
  }

  showPotentialSales() {
    // this.salesRepCheck = true;
    // this.pSalesCheck = false;
    // this.pProductsCheck = false;
    //
    // this.closedSale = false;
    // this.salesRepCheck = true;
    // this.potentialSales = true;
    // this.mainPage = false;
    // setTimeout(() => {
    //   this.content.resize();
    // }, 80);

    this.navCtrl.push(BysalesrepPage);
  }

  showTrndingProducts() {
    this.navCtrl.push(TrendingproductsPage);
  }

  gotToStats() {

    this.salesRepCheck = false;
    this.pSalesCheck = false;
    this.pProductsCheck = false;

    this.mainPage = true;
    this.closedSale = false;
    this.potentialSales = false;
    setTimeout(() => {
      this.content.resize();
    }, 80);


    var canvas =  <HTMLCanvasElement> document.getElementById("myChart");
    this.pieCanvas = canvas.getContext('2d');
    this.papulateData();
  }


  static getChart(context, chartType, data, options?) {
    return new Chart(context, {
      type: chartType,
      data: data,
      options: options
    });
  }

  bySalesRep() {
    this.salesRepCheck = true;
    this.pSalesCheck = false;
    this.pProductsCheck = false;
  }

  byCustomer() {
    this.salesRepCheck = false;
    this.pSalesCheck = true;
    this.pProductsCheck = false;
  }

  byProducts() {
    this.salesRepCheck = false;
    this.pSalesCheck = false;
    this.pProductsCheck = true;
  }


  papulateData() {
    this.pieChart = new Chart(this.pieCanvas, {

      type: 'pie',
      data: {
        labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
        datasets: [{
          label: '# of Votes',
          data: [12, 19, 3, 5, 2, 3],
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(255, 159, 64, 0.2)'
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
          ]
        }]
      }

    });
    this.gVLogger.log("Executed");
    // this.pieChart.update({
    //   duration: 800,
    //   easing: 'easeOutBounce'
    // });
  }


  reportsStatisticsByHold(){
    let userId = this.cartManager.getSalesManId();
    //this.gVLogger.log("Download template clicked");
    let body={};

    let pathToApi = '';
    if(this.salePerson.restrictToAssignedCustomers == 0){
      body = {
        startDate: this.startDate,
        endDate: this.endDate,
        orderStatus: 2,
        statsFor:2,
        userID: userId
      };
      pathToApi = 'reports/potentialaccounts/statistics'
    }
    if(this.salePerson.restrictToAssignedCustomers == 1){
      body = {
        startDate: this.startDate,
        endDate: this.endDate,
        orderStatus: 2,
        statsFor:4,
        userID: userId
      };
      pathToApi = 'reports/potentialaccounts/statistics';
    }
    this.api.postlocal(pathToApi, body)
      .map(res=>res.json())
      .subscribe(res=>{
        this.reportStats = res.data;
        this.reportStats.totalOrdersAmount = Api.nFormatter(this.reportStats.totalOrdersAmount);
        this.reportStats.totalBookmarksCount = Api.nFormatter(this.reportStats.totalBookmarksCount);

      },err=>{

      });
  }
  palcedorderstats(){
    let userId = this.cartManager.getSalesManId();

    //this.gVLogger.log("Download template clicked");
    let body = {
      startDate: this.startDate,
      endDate: this.endDate,
      orderStatus: 2,
      statsFor:4,
      userID: userId
    };
    let pathToApi = '';
    if(this.salePerson.restrictToAssignedCustomers == 0){
      pathToApi = 'user/statistics'
      this.api.getlocal(pathToApi)
      .map(res=>res.json())
      .subscribe(res=>{
        this.stats = res;
        this.stats.totalSales = Api.nFormatter(this.stats.totalOrderAmountWT);

        this.stats.averageSales = Api.nFormatter(this.stats.totalOrderAmountWT / this.stats.totalOrdersWT);

      },err=>{

      });
    }
    if(this.salePerson.restrictToAssignedCustomers == 1){
      pathToApi = 'reports/app/potentialaccounts/palcedorderstats';
      this.api.postlocal(pathToApi, body)
      .map(res=>res.json())
      .subscribe(res=>{
        this.stats = res;
        this.stats.totalSales = Api.nFormatter(this.stats.totalOrderAmountWT);

        this.stats.averageSales = Api.nFormatter(this.stats.totalOrderAmountWT / this.stats.totalOrdersWT);

      },err=>{

      });
    }

  }



  nFormatter(num) {
    if (num == null) {
      num = 0;
    }
    let digits = 1;
    var si = [
      {value: 1E18, symbol: "E"},
      {value: 1E15, symbol: "P"},
      {value: 1E12, symbol: "T"},
      {value: 1E9, symbol: "B"},
      {value: 1E6, symbol: "M"},
      {value: 1E3, symbol: "k"}
    ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/, i;
    for (i = 0; i < si.length; i++) {
      if (num >= si[i].value) {
        return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/reports.ts